import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function UserSidebarSocialMedias({
  website = '',
  facebook = '',
  twitter = '',
  linkedin = '',
}) {
  const pattern = [{
    icon: 'globe',
    url: website,
  }, {
    icon: 'facebook-square',
    url: facebook,
  }, {
    icon: 'twitter-square',
    url: twitter,
  }, {
    icon: 'linkedin',
    url: linkedin,
  }]

  let existingUrls = 0

  pattern.forEach((item) => {
    if (item.url) {
      existingUrls += 1
    }
  })

  if (existingUrls > 0) {
    return (
      <section className="user-data__section l-inner">
        <div className="social-buttons">
          <div className="row">
            {pattern.map((network, i) => network.url && (
            <div className="col" key={`user-social-${i}`}>
              <a
                href={network.url}
                target="_blank"
                className="social-icon-circle social-icon-circle--small link link--primary"
              >
                <Icon type={[network.icon === 'globe' ? 'far' : 'fab', network.icon]} notSpaced />
              </a>
            </div>
            ))}
          </div>
        </div>
      </section>
    )
  } return false
}

UserSidebarSocialMedias.propTypes = {
  website: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
}

export default UserSidebarSocialMedias
